import {
    UptimeBox,
    UptimeButton
  } from '@uptime/uptime-component';
import styled from 'styled-components';
import DefaultUptimeTheme from 'utils/lumosTheme';

export const StyledActionButton = styled(UptimeButton)`
   ${({theme} : {theme: typeof DefaultUptimeTheme}) => `
    width: 100%;
    display: flex;
    padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[13]}px ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[7]}px;
    align-items: center;
    justify-content: flex-start;
    background: ${!!theme.uptimeColors.generalColors.button?.mobileSideSheet?.enabled ? theme.uptimeColors.generalColors.button?.mobileSideSheet?.enabled : 'rgba(51, 0, 114, 0.30)'};
    height: 48px;

    &:hover {
        background: ${!!theme.uptimeColors.generalColors.button?.mobileSideSheet?.hover ? theme.uptimeColors.generalColors.button?.mobileSideSheet?.hover : theme.uptimeColors.mainTheme.secondary};
    }

    ${!!theme.uptimeColors.generalColors.button?.mobileSideSheet?.pressed ? `
      &:active {
        background: ${theme.uptimeColors.generalColors.button?.mobileSideSheet?.pressed};
      }
      &:focus {
        background: ${theme.uptimeColors.generalColors.button?.mobileSideSheet?.pressed};
        border: 1px solid ${theme.uptimeColors.generalColors.button?.mobileSideSheet?.pressed};
        outline-color: ${theme.uptimeColors.generalColors.button?.mobileSideSheet?.pressed};
       }
    ` : ''} 

    & > span {
      height: 100%;
      display: flex;
      align-items: center;
      font-weight: 600;
      line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
      letter-spacing: 0.4px;

      & > svg {
        width: 20px;
        height: 20px;
        margin-right: ${theme.uptimeSpace[9]}px;
      }
    }
  `}
`;
export const StyledButtonWrapper = styled(UptimeBox)`
   ${({theme} : {theme: typeof DefaultUptimeTheme}) => `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${theme.uptimeSpace[4] + 1}px;
    width: 100%;
  `}
`;